import { gridSizeMdLg12, texto, gridSizeMdLg6 } from "@/shared"
import { CustomNote, SampleCheckbox } from "@/shared/components/ui"
import { Grid, Alert, AlertTitle, Typography } from "@mui/material"
import { UseFormReturn } from "react-hook-form"
//import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CargarDocumentoSoluccionCosteada from "@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada"
import { IPreventaPymesForm } from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface"
import { TipoSolicitudesEnum } from "@/shared/interfaces"

/* const recomendacionLista = [
  'RUC de la entidad para el servicio.',
  'Identificación del representante legal.',
  'Nombramiento.',
  'Documentos necesarios.',
] */


interface TabDocumentosPreventaProps {
  editSupervisor: boolean
  form: UseFormReturn<IPreventaPymesForm, any, IPreventaPymesForm>
  docHabilitantes: File | null
  setDocHabilitantes: React.Dispatch<React.SetStateAction<File | null>>;
  handleValidarTipoVenta: string
}

export default function TabDocumentosPreventaPymes({
  editSupervisor,
  form,
  docHabilitantes,
  setDocHabilitantes,
  handleValidarTipoVenta
}: TabDocumentosPreventaProps) {

  const {
  } = form

  return (
    <Grid container spacing={3} justifyContent={"end"}>
      <Grid item {...gridSizeMdLg12}>
        {false && (
          <Grid item {...gridSizeMdLg12}>
            <Alert
              severity="info"
              onClose={() => {
                //setErrorCedula(false);
              }}
            >
              <AlertTitle>Información</AlertTitle>
              <Grid container>
                <Grid item xs={12}>
                  <span>{texto.error_imagen_cedula}</span>
                </Grid>
              </Grid>
            </Alert>
          </Grid>
        )}
      </Grid>

      <Grid item {...gridSizeMdLg6}>
        <Grid container spacing={1}>

          <Grid item xs={12} >
            <Typography variant="subtitle1">Documentación</Typography>
          </Grid>

          {/* <Grid item xs={12}>
            {recomendacionLista.map((value, key) => {
              return <Alert key={key}
                style={{ background: 'none', padding: 1 }} icon={<TaskAltIcon color="primary" />}>
                {value}
              </Alert>
            })}
          </Grid> */}

          <CargarDocumentoSoluccionCosteada
            idInput='documento-preventa'
            buttonText={'Documentos habilitantes'}
            selectedImage={docHabilitantes}
            setSelectedImage={setDocHabilitantes}
          />

        </Grid>
      </Grid>


      <Grid
        item
        {...gridSizeMdLg6}
        className={
          editSupervisor
            ? "editSupervisor-disabled"
            : "editSupervisor-enabled"
        }
      >
        <Grid container >


          {
            handleValidarTipoVenta != TipoSolicitudesEnum.PYMES && (
              <CustomNote
                note={`Nota: Todo evento o canje debe ser gestionado a través del supervisor asignado.`}
              />
            )
          }

          {
            handleValidarTipoVenta == TipoSolicitudesEnum.PYMES && (
              <>
                <Grid item {...gridSizeMdLg12}>
                  <SampleCheckbox
                    label="Requiere contratos físicos"
                    name="pre_requiere_contrato_fisico"
                    control={form.control}
                    defaultValue={
                      !!form.getValues().pre_requiere_contrato_fisico
                    }
                    size={gridSizeMdLg12}
                  />
                </Grid>

                <CustomNote
                  note="Nota: En caso de que el contrato sea físico, no será posible continuar con la venta hasta que el documento firmado sea cargado en el sistema y aprobado."
                />
              </>
            )
          }


        </Grid>
      </Grid>
    </Grid>
  )

}